import { compCardSystems } from '@biteinc/common';
import { allEnumValues, CardEntryMethod } from '@biteinc/enums';
export const compCardAuthDataSchema = {
    displayName: 'comp card auth data',
    type: 'object',
    fields: {
        system: {
            type: 'int',
            values: compCardSystems,
            required: true,
        },
        cardNumber: {
            type: 'keyString',
            required: true,
            conditions: [
                {
                    field: 'system',
                    values: compCardSystems,
                },
            ],
        },
        cardPin: {
            type: 'keyString',
            conditions: [
                {
                    field: 'system',
                    values: compCardSystems,
                },
            ],
        },
        cardEntryMethod: {
            type: 'int',
            values: allEnumValues(CardEntryMethod),
            required: true,
        },
    },
};
//# sourceMappingURL=comp_card_auth_data_schema.js.map